<template>
  <div>
    <div class="fxedTop">
      <div class="container">
        <div class="row" style="margin-bottom: 20px">
          <div style="height: 40px"></div>
          <div class="rowRight">
            <div class="login">
              <div style="display: flex; align-items: center">
                <span
                  style="
                    font-size: 20px;
                    font-weight: bold;
                    color: red;
                    margin: 0 20px;
                    font-size: 24px;
                  "
                  >客服电话: 400-133-5833</span
                >
              </div>
              <div>
                <a
                  :href="aHref"
                  target="_blank"
                  style="
                    display: block;
                    color: #fff;
                    text-decoration: none;
                    border: 1px solid #fff;
                    border-radius: 5px;
                    padding: 2px 10px;
                    margin-right: 20px;
                    font-size: 20px;
                  "
                  >管理员登录</a
                >
              </div>
              <div
                v-if="userInfo && userInfo?.realName"
                style="display: flex; align-items: center">
                <img
                  :src="userInfo.certificateHeadPhoto"
                  alt=""
                  style="
                    width: 30px;
                    height: 30px;
                    border-radius: 30px;
                    margin-right: 10px;
                    font-size: 20px;
                  " />
                <div style="color: #fff">{{ userInfo.realName }}</div>
              </div>
              <div v-else class="userInfo" @click="showLogin">学员登录</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="rowLeft">
            <div
              class="menuItem"
              v-for="(item, index) in navList"
              :key="index"
              @click="handleUrl(item)">
              <div class="menuName">
                <div style="flex: 1">
                  <div style="margin-bottom: 6px">{{ item.name }}</div>
                  <div v-if="item.isActive" class="menuActive"></div>
                </div>
                <div
                  v-if="item.isLine"
                  class="borderR"
                  style="height: 20px"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MenuItem from "@/components/MenuItem";
import { getUserInfo } from "@/api/user";
export default {
  name: "FixedTop",
  components: {
    MenuItem,
  },
  data() {
    return {
      aHref: window.origin + "/admin/#/",
      navList: [
        {
          name: "首页",
          toUrl: "/",
          isToUrl: true,
          isActive: false,
          isLine: true,
        },
        {
          name: "在线课程",
          toUrl: "/course",
          isToUrl: true,
          isActive: false,
          isLine: true,
        },
        {
          name: "通知公告",
          toUrl: "/noticeList",
          isToUrl: true,
          isActive: false,
          isLine: true,
        },
        {
          name: "线下培训认定",
          toUrl: "/datarmine",
          isToUrl: true,
          isActive: false,
          isLine: true,
        },
        {
          name: "下载专区",
          toUrl: "/policyList",
          isToUrl: true,
          isActive: false,
          isLine: true,
        },
        {
          name: "联系我们",
          toUrl: "/HelpCenter",
          isToUrl: true,
          isActive: false,
          isLine: false,
        },
        {
          name: "个人中心",
          toUrl: "/my",
          isToUrl: true,
          isActive: false,
          isLine: false,
        },
      ],
      userInfo: {},
      cratList: [],
      cartTopNubmer: 0, // 购物车数量
      emitText: "",
    };
  },
  created() {
    this.navList.forEach((item, index) => {
      item.isLine = true;
      if (this.$route.fullPath === item.toUrl) {
        item.isToUrl = false;
        item.isActive = true;
      }
    });
    this.navList[this.navList.length - 1].isLine = false;
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    if (userInfo) {
      userInfo.realName = userInfo.realName.slice(0, 1) + "**";
      this.userInfo = userInfo;
    } else {
      getUserInfo().then((res) => {
        this.userInfo = res.data;
      });
    }
    // 将数据存入缓存// 数据存入缓存
    try {
      this.cratList = JSON.parse(localStorage.getItem("cratList")) || [];
      this.cartTopNubmer = this.cratList.length;
    } catch {}

    this.aHref = window.origin + "/admin/#/";
  },
  methods: {
    showLogin() {
      if (this.$route.path === "/login") {
        return;
      }
      this.$router.push("/login");
    },
    handleUrl(item, index) {
      if (item && item.isToUrl) {
        if (this.$route.fullPath === item.toUrl) {
          return;
        }
        this.$router.push(item.toUrl);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.groupLecturer {
  display: flex;
  justify-content: space-between;

  font-weight: 400;
  font-size: 14px;
  color: #9b9b9b;
  .seeDetails {
    cursor: pointer;
    color: #6aa7eb;
  }
}
.fxedTop {
  font-size: 14px;
  width: 100vw;
  .container {
    padding-top: 20px;
    width: 1400px;
    margin: 0 auto;
    .row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .rowLeft {
        width: 1400px;
        display: flex;
        align-items: center;
        flex: 1;
        height: 100%;
        box-sizing: border-box;
        border-radius: 30px 0 30px 0;
        overflow: hidden;
        .menuItem {
          flex: 1;
          .menuName {
            text-align: center;
            font-size: 20px;
            color: #ffffff;
            cursor: pointer;
            display: flex;
            align-items: center;
            .menuActive {
              width: 60%;
              margin: 0 auto;
              height: 4px;
              border-radius: 4px;
              background: #fff;
            }
          }
        }
      }
      .rowRight {
        display: flex;
        align-items: center;

        .search {
          width: 450px;
          height: 48px;
          overflow: hidden;
          background: #f5f5f5;
          border-radius: 50px;
          position: relative;
          z-index: 2;
          display: flex;
          margin-right: 30px;
          .searchInput {
            padding-left: 20px;
            box-sizing: border-box;
            border: none;
            background: #f5f5f5;
            border-radius: 50px;
            flex: 1;
            line-height: 48px;
            color: #ccc;
            font-size: 14px;
          }
          .searchIcon {
            width: 32px;
            height: 32px;
            padding: 12px;
            margin-right: 20px;
            box-sizing: border-box;
            img {
              width: 20px;
              height: 20px;
            }
          }
        }
        .cart {
          width: 20px;
          height: 20px;
          margin-right: 30px;
          position: relative;
          &:hover {
            cursor: pointer;
          }
          img {
            width: 100%;
            height: 100%;
          }
          .cartNum {
            width: 20px;
            height: 20px;
            background-color: red;
            text-align: center;
            line-height: 20px;
            font-size: 12px;
            color: #fff;
            border-radius: 20px;
            position: absolute;
            top: -50%;
            right: -50%;
          }
        }
        .login {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          box-sizing: border-box;
          .userInfo {
            display: flex;
            align-items: center;
            margin-right: 10px;
            font-weight: 400;
            color: #fff;
            cursor: pointer;
            border: 1px solid #fff;
            border-radius: 5px;
            padding: 2px 10px;
            font-size: 20px;
            .avatarUrl {
              width: 30px;
              height: 30px;
              border-radius: 30px;
            }
            .realName {
              margin-left: 10px;
              color: #fff;
            }
          }
          .loginItem {
            padding: 0 10px;
            font-size: 16px;
            color: #0d6fc2;
            &:hover {
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
